<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="sidebarx"
    spacer
    v-model="productConfig.isOpen"
    id="update-service"
  >
    <div class="flex items-center justify-between px-6 pb-2">
      <h4 class="font-bold text-2xl">Update Product</h4>
      <feather-icon icon="XIcon" @click.stop="closeSidebar" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <div class="sidebar-content p-6 overflow-auto update-service-form">
      <div>
        <!-- <p>Service Name</p> -->
        <h4 class="font-bold text-lg mb-3">Product name</h4>
        <vs-input
          v-validate="'required'"
          name="service_name"
          placeholder="Product Name"
          v-model="service_name"
          class="w-full"
          :danger="errors.has('service_name')"
          danger-text="The product name field is required"
        />
        <h4 class="font-bold text-lg mb-3 mt-4">Product description</h4>
        <vs-textarea v-model="service_note" height="70" />
        <h4 class="font-bold text-lg mb-3">Product price</h4>
        <vs-input v-model="service_price" v-on:keypress="isNumber($event)" icon="attach_money" class="w-full mb-5" :clearable="false" :searchable="false" :maxlength="9" :disabled="leave_blank"/>
        <div class="flex align-center"><vs-checkbox class="m-0 mr-2 mb-6" v-model="leave_blank">Leave blank</vs-checkbox></div>
        <!-- <vs-row>
          <vs-col vs-w="6" class="pr-3 service-price">
            <v-select
              v-model="selectedPrice"
              :options="prices"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              class="w-full"
              :clearable="false"
              :searchable="false"
            />
            <br />
          </vs-col>
          <vs-col vs-w="6" class="pl-3">
            <div v-if="selectedPrice.id === 2">
              <vs-input
                v-model="service_price"
                v-on:keypress="isNumber($event)"
                icon="attach_money"
                class="w-full"
                :clearable="false"
                :searchable="false"
                :maxlength="9"
              />
            </div>
          </vs-col>
        </vs-row> -->
        <!-- <p>Category Name</p> -->
        <h4 class="font-bold text-lg mb-4">Category name</h4>
        <v-select
          @input="selectId($event)"
          :options="cateData"
          v-model="cateId"
          class="w-full"
          disabled
          :clearable="false"
          :searchable="false"
          :class="{'invalid-border': errors.has('cateId')}"
        ></v-select>
        <!-- <span class="text-danger text-xs error-text-input span-text-validation hide-error mt-3" :class="{'show-error': errors.has('cateId')}">The reminder after date field is required</span> -->
        <!-- <p>Online booking visibility</p> -->
        <h4 class="font-bold text-lg mb-6 mt-4">Online booking visibility</h4>
        <div class="flex align-center">
          <vs-checkbox
            class="m-0 mr-2"
            v-model="service_status"
          >Service visible to client during online booking.</vs-checkbox>
        </div>
        <p class="text-grey-custom" style="font-size: 12px">When enabled, this service will appear in your Booking Site and Embedded Widgets. This will not affect your ability to choose it when you create an appointment.</p>
        <!-- <p v-if="config.service_distinction">Service available on: </p>
        <v-select label="name" :options="distinctionSelect" v-model="distinctionValue" class="w-full" :clearable="false" :searchable="false" v-if="config.service_distinction"></v-select>-->
        <div v-if="config.service_distinction">
          <!-- Availability: -->
          <h4 class="font-bold text-lg mb-6">Availability</h4>
          <vs-checkbox
            class="m-0 mr-2 mb-6"
            v-model="gocheckin_available"
          >Service available on GoCheckin.</vs-checkbox>
          <!-- <vs-checkbox class="m-0 mr-2" v-model="gobooking_available">Service available on GoBooking.</vs-checkbox> -->
        </div>
        <h4 class="text-lg font-bold mb-4">Status</h4>
        <ul class="switch-container">
          <li class="flex align-center">
            <vs-switch v-model="product_is_active" @click.stop="switchActive"/>
            <p class="ml-3 p-0">
              <span class="text-primary" v-if="product_is_active">Active</span>
              <span class="text-grey-custom" v-else>Inactive</span>
            </p>
          </li>
        </ul>
      </div>
    </div>
    <div class="flex flex-wrap items-center p-6 justify-center" slot="footer">
      <vs-button class="mr-6" @click="submitData" style="min-width: 140px">Submit</vs-button>
      <vs-button type="border" color="danger" @click.stop="closeSidebar" style="min-width: 140px">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: "vs-update-products",
  components: {
    'v-select': vSelect,
    SideBarItem: () => import("../../components/SideBarItem.vue"),
  },
  props: {
    productConfig: {
      type: Object,
      required: true
    },
    serviceData: {
      type: Object,
      required: true
    },
    cateData: {
      type: Array,
      required: true,
    },
    cateName: {
      type: String,
      required: true,
    }
  },
  data() {
      return {
          number0: 0,
          name: this.serviceData.name,
          note: this.serviceData.note,
          is_active: this.serviceData.status,
          price: this.serviceData.price ? this.serviceData.price : 0,
          leave_blank: (this.serviceData.price == null || this.serviceData.price == '') ? true : false,
          status: (this.serviceData.web_booking_visible == 0) ? false : true,
          cateId: this.cateName,
          selectedId: this.serviceData.category_id,
          hours: [
            {label: '0 hrs' , value: '0'},{label: '1 hrs' , value: '1'},{label: '2 hrs' , value: '2'},{label: '3 hrs' , value: '3'},
            {label: '4 hrs' , value: '4'},{label: '5 hrs' , value: '5'},{label: '6 hrs' , value: '6'},{label: '7 hrs' , value: '7'},
            {label: '8 hrs' , value: '8'},{label: '9 hrs' , value: '9'},{label: '10 hrs' , value: '10'},{label: '11 hrs' , value: '11'},
            {label: '12 hrs' , value: '12'},{label: '13 hrs' , value: '13'},{label: '14 hrs' , value: '14'},
          ],
          selectedHour: {label: parseInt(this.serviceData.duration / 60) + ' hrs', value: parseInt(this.serviceData.duration/60)},
          minutes: [
            {label: '0 mins' , value: '0'},{label: '5 mins' , value: '5'},{label: '10 mins' , value: '10'},{label: '15 mins' , value: '15'},
            {label: '20 mins' , value: '20'},{label: '25 mins' , value: '25'},{label: '30 mins' , value: '30'},{label: '35 mins' , value: '35'},
            {label: '40 mins' , value: '40'},{label: '45 mins' , value: '45'},{label: '50 mins' , value: '50'},{label: '55 mins' , value: '55'},
          ],
          selectedMinute: {label: parseInt(this.serviceData.duration % 60) + ' mins', value: parseInt(this.serviceData.duration%60)},
          prices: [
            {id:1, label: 'Leave blank'},
            {id:2, label: 'Add price'}
          ],
          selectedPrice: {id: 1, label: 'Leave blank'},
          distinctionSelect: [
            {name: "Show on GoCheckin & GoBooking", value: 0, },
            {name: "Show only on GoCheckin", value: 1, },
            {name: "Show only on GoBooking", value: 2, },
          ],
          distinctionValue: {name: "Show on GoCheckin & GoBooking", value: 0, },
          gocheckin_available: (this.serviceData.group_id == 1 || this.serviceData.group_id == null) ? true : false,
          gobooking_available:  true,
      }
  },
  computed: {
      product_is_active: {
        get() { return this.is_active; },
        set(value) {
          this.is_active = value;
        }
      },
      service_name: {
        get() { return this.name; },
        set(value) {
          this.name = value;
        }
      },
      service_note: {
        get(){
          if(this.note) {
            return this.note;
          } else {
            return '';
          }
        },
        set(value){
          this.note = value;
        }
      },
      service_hour: {
        get(){return {label:this.selectedHour.label, value:this.selectedHour.value}},
        set(label,value){
          this.selectedHour.label = label;
          this.selectedHour.value = value;
        }
      },
      service_minute: {
        get(){return {label:this.selectedMinute.label, value:this.selectedMinute.value}},
        set(label,value){
          this.selectedMinute.value = value;
          this.selectedMinute.label = label;
        }
      },
      service_price: {
        get(){return this.price},
        set(value){
          this.price = value;
        }
      },
      service_cateId: {
        get() {
          return this.cateId;
        },
        set(value) {
          this.cateId = value;
        }
      },
      service_status: {
        get() {return this.status},
        set(value){
          this.status = value;
        }
      },
      id: {
        get(){
          return this.serviceData.id;
        },
        set(){}
      },
      config(){
        return this.$store.getters['auth/config'];
      }
    },
   watch: {
    productConfig: {
      immediate: true,
      deep: true,
      handler() {
        this.name = this.serviceData.name;
        this.note = this.serviceData.description,
        this.price = this.serviceData.price,
        this.leave_blank = (this.serviceData.price == null || this.serviceData.price == '') ? true : false;
        this.status = (this.serviceData.web_booking_visible == 0) ? false : true;
        this.gocheckin_available = (this.serviceData.group_id == 2 || this.serviceData.group_id == null) ? true : false;
        this.gobooking_available = true;
        this.cateId = this.cateName;
        if(this.serviceData.price == null || this.serviceData.price == ''){
          this.selectedPrice = {id:1,label: 'Leave blank'};
        }else{
          this.selectedPrice = {id:2, label: 'Add price'};
        }
        this.errors.clear();
        if(this.productConfig.isOpen) {
          document.body.classList.add('overflow-hidden');
          document.body.style.position = '';
          document.body.style.top = '';
          window.scrollTo(0, parseInt(scrollY || '0') * -1);
        } else {
          document.body.classList.remove('overflow-hidden');
        }
      }
    }
  },
  methods: {
    switchActive(){
      this.is_active = this.is_active;
    },
    isNumber: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) || (charCode == 46 && this.service_price.indexOf(".") != -1)) {
            evt.preventDefault();
        } else {
            return true;
        }
    },
    selectId(e) {
      this.selectedId = e.id;
    },
    closeSidebar() {
      this.$emit("CloseSidebarProduct");
    },
    // checkAvailable(type){
    //   if (this.gobooking_available == false && this.gocheckin_available == false){
    //     // if (type == "checkin") {
    //       //   this.gocheckin_available = true;
    //     // } else if (type=="booking") {
    //     //   this.gobooking_available = true;
    //     // }
    //     this.$vs.notify({
    //       color: "warning",
    //         title: "Alert",
    //         text: "This service must have at least one app!"
    //       });
    //     this.gobooking_available = true;
    //   }
    // },
    submitData() {
      // if(this.selectedPrice.id == 1){
      //   this.price = ''
      // }else{
        if(this.price == null){
          this.price = 0;
        }
      // }
      if(this.selectedId == null){
        this.selectedId = '';
      }
      let group_id = "both";
      if (this.gocheckin_available == true && this.gobooking_available == false){
        group_id = 2;
      } else if (this.gocheckin_available == false && this.gobooking_available == true){
        group_id = 1;
      }
      if(this.name != ''){
        const obj = {
          id: this.id,
          name: this.name,
          category_id: (this.selectedId != 999999) ? this.selectedId : '',
          price: this.leave_blank || this.price == '' ? '' : parseFloat(this.price),
          web_booking_visible: this.status ? 1 : 0,
          description: this.note,
          // duration: parseInt(this.selectedHour.value*60) + parseInt(this.selectedMinute.value),
          group_id,
          status: this.is_active ? 1 : 0
        };
        this.$emit("UpdateProductInfo" , obj);
        this.closeSidebar();
      }
       this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          // alert("form submitted!");
        } else {
          // form have errors
        }
      })
    },
  }
};
</script>
